export enum EmailTemplateType {
  DealConfirmationEmail = 1,
  DepositReminderEmail = 2
}

export interface EmailTemplatesResponse {
  id: string;
  templateType: EmailTemplateType;
  htmlContent: string;
  wrappedHtmlContent: string;
  emailWrapperTemplate: string;
  projectId?: string | null;
  isProjectTemplate?: boolean;
}

export interface EmailTemplateVariables {
  templateName: string;
  variables: string[];
}

export interface EmailTemplatePreviewResponse {
  originalHtmlContent?: string;
  renderedHtml: string;
  wrappedHtmlContent: string;
  emailWrapperTemplate: string;
}

export interface WelcomeEmailStatusDto {
  isWelcomeEmailSent: boolean;
  isWelcomeEmailSkipped: boolean;
  canSendWelcomeEmail: boolean;
}

export interface WelcomeEmailRecipient {
  name: string;
  email: string;
  /** Purchaser, Co-buyer, Realtor or Sales office. */
  role: string;
}

export interface WelcomeEmailPreview {
  subject: string;
  html: string;
  to: WelcomeEmailRecipient | null;
  cc: WelcomeEmailRecipient[];
  projectDocuments: string[];
  aps: { available: boolean; fileName: string; reason?: string | null };
}

export interface WelcomeEmailCustomDocument {
  s3DocumentId: string;
  fileName: string;
}

export interface SendWelcomeEmailOptions {
  attachAps: boolean;
  customDocuments: WelcomeEmailCustomDocument[];
}
